// extracted by mini-css-extract-plugin
export default {"infoText":"_3A-u0","offerLink":"_29tLT"};